import { render, staticRenderFns } from "./InnerComponentItem.vue?vue&type=template&id=b1f8b222&scoped=true&"
import script from "./InnerComponentItem.vue?vue&type=script&lang=js&"
export * from "./InnerComponentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f8b222",
  null
  
)

export default component.exports